import { ReactNode } from "react";

import Form, { FormProps } from "client/common/components/forms/Form";

import styles from "../styles/OnboardingSubscriptionsStepLayout.module.less";

type OnboardingSubscriptionsStepLayoutProps = { stepper: ReactNode; children: ReactNode };

const OnboardingSubscriptionsStepLayout = ({
  stepper,
  children,
}: OnboardingSubscriptionsStepLayoutProps) => {
  return (
    <div className={styles.layout}>
      {stepper}
      {children}
    </div>
  );
};

type OnboardingSubscriptionsStepFormProps = FormProps & { className?: never };

const OnboardingSubscriptionsStepForm = ({
  children,
  ...rest
}: OnboardingSubscriptionsStepFormProps) => {
  return (
    <Form {...rest} className={styles.form}>
      {children}
    </Form>
  );
};

type OnboardingSubscriptionsStepTitleProps = {
  children: ReactNode;
};

const OnboardingSubscriptionsStepTitle = ({ children }: OnboardingSubscriptionsStepTitleProps) => {
  return <div className={styles.title}>{children}</div>;
};

type OnboardingSubscriptionsStepDescriptionProps = {
  children: ReactNode;
};

const OnboardingSubscriptionsStepDescription = ({
  children,
}: OnboardingSubscriptionsStepDescriptionProps) => {
  return <div className={styles.description}>{children}</div>;
};

type OnboardingSubscriptionsFooterProps = {
  children: ReactNode;
};

const OnboardingSubscriptionsStepFooter = ({ children }: OnboardingSubscriptionsFooterProps) => {
  return <div className={styles.footer}>{children}</div>;
};

export default Object.assign(OnboardingSubscriptionsStepLayout, {
  Form: OnboardingSubscriptionsStepForm,
  Title: OnboardingSubscriptionsStepTitle,
  Description: OnboardingSubscriptionsStepDescription,
  Footer: OnboardingSubscriptionsStepFooter,
});
